import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductProtectFilledSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductProtectFilledSvg = ({
  ...svgProps
}: ProductProtectFilledSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path d="M9.5 17.0001C9.44 17.0001 9.39 17.0001 9.33 16.9701C2.08 14.3901 2 4.90006 2 4.50006C2 4.28006 2.14 4.09006 2.34 4.03006C5.27 3.05006 9.24 1.07006 9.28 1.05006C9.42 0.980059 9.59 0.980059 9.73 1.05006C9.77 1.07006 13.73 3.05006 16.66 4.02006C16.86 4.09006 17 4.28006 17 4.49006C17 4.89006 16.92 14.3101 9.67 16.9601C9.61 16.9801 9.56 16.9901 9.5 16.9901V17.0001ZM3.01 4.85006C3.1 6.54006 3.81 13.8101 9.49 15.9601C15.18 13.7401 15.89 6.53006 15.98 4.85006C13.42 3.95006 10.35 2.47006 9.49 2.05006C8.64 2.47006 5.57 3.95006 3 4.85006H3.01Z" />
    <path d="M9.49 14.8301C9.42 14.8301 9.34 14.8101 9.27 14.7801C5.52 12.9701 4.43 8.45006 4.11 5.92006C4.08 5.69006 4.21 5.47006 4.43 5.39006C6.33 4.66006 8.28 3.75006 9.28 3.27006C9.42 3.20006 9.57 3.20006 9.71 3.27006C10.71 3.75006 12.67 4.66006 14.56 5.39006C14.77 5.47006 14.91 5.69006 14.88 5.92006C14.56 8.43006 13.46 12.9301 9.71 14.7701C9.64 14.8001 9.56 14.8201 9.49 14.8201V14.8301Z" />
  </SvgWrapper>
);
